export default "__VITE_ASSET__KCFeojuS__"